import { TrashIcon } from '@navikt/aksel-icons';
import { Button } from '@digdir/designsystemet-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
}

export const RemoveButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <Button variant="tertiary" onClick={onClick} aria-label={t('register.solar.form.buttons.remove')}>
      {t('register.solar.form.buttons.remove')} <TrashIcon aria-hidden />
    </Button>
  );
};
